/* =============================================
   MI TIERRA LATINA — SHOPIFY THEME JS
   ============================================= */

'use strict';

/* ===== NAVBAR FIXED STATE ===== */
const MtlNavScroll = {
  nav: null,
  ticking: false,

  init() {
    this.nav = document.querySelector('.mtl-nav');
    if (!this.nav) return;
    this.nav.classList.remove('scrolled');
  },

  check() {
    if (!this.nav) return;
    this.nav.classList.remove('scrolled');
  }
};

/* ===== CART DRAWER ===== */
const MtlCart = {
  drawer: null,
  overlay: null,
  countEls: null,

  init() {
    this.drawer = document.getElementById('mtl-cart-drawer');
    this.overlay = document.getElementById('mtl-cart-overlay');
    this.countEls = document.querySelectorAll('.mtl-cart-count');

    document.querySelectorAll('.mtl-open-cart').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    const closeBtn = document.getElementById('mtl-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });

    this.refresh();
  },

  open() {
    if (this.drawer) this.drawer.classList.add('open');
    if (this.overlay) this.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  },

  close() {
    if (this.drawer) this.drawer.classList.remove('open');
    if (this.overlay) this.overlay.classList.remove('open');
    document.body.style.overflow = '';
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
      this.updateCount(cart.item_count);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  },

  render(cart) {
    const body = document.getElementById('mtl-cart-body');
    const footer = document.getElementById('mtl-cart-footer');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="mtl-cart-empty">
          <span class="mtl-cart-empty-icon">🛒</span>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="mtl-btn mtl-btn-primary" style="margin:16px auto 0;display:inline-flex;">Shop now →</a>
        </div>`;
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';

    body.innerHTML = cart.items.map(item => `
      <div class="mtl-cart-item" data-key="${item.key}">
        <div class="mtl-cart-item-img">
          <img src="${item.image || ''}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="mtl-cart-item-info">
          <div class="mtl-cart-item-name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mtl-cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="mtl-cart-item-bottom">
            <div class="mtl-cart-qty">
              <button type="button" class="qty-minus" data-key="${item.key}" aria-label="Decrease">−</button>
              <span class="mtl-cart-qty-num">${item.quantity}</span>
              <button type="button" class="qty-plus" data-key="${item.key}" aria-label="Increase">+</button>
            </div>
            <div class="mtl-cart-item-price">${MtlCart.formatMoney(item.final_line_price)}</div>
          </div>
          <button type="button" class="mtl-cart-remove" data-key="${item.key}">Remove</button>
        </div>
      </div>`).join('');

    const totalEl = document.getElementById('mtl-cart-total-price');
    if (totalEl) totalEl.textContent = this.formatMoney(cart.total_price);

    // Re-bind buttons
    body.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = cart.items.find(i => i.key === btn.dataset.key);
        if (item) this.updateItem(btn.dataset.key, item.quantity - 1);
      });
    });
    body.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = cart.items.find(i => i.key === btn.dataset.key);
        if (item) this.updateItem(btn.dataset.key, item.quantity + 1);
      });
    });
    body.querySelectorAll('.mtl-cart-remove').forEach(btn => {
      btn.addEventListener('click', () => this.updateItem(btn.dataset.key, 0));
    });
  },

  async updateItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      await this.refresh();
    } catch (e) {
      console.error('Cart update failed', e);
    }
  },

  updateCount(count) {
    this.countEls = document.querySelectorAll('.mtl-cart-count');
    this.countEls.forEach(el => {
      el.textContent = count;
      el.classList.add('bump');
      setTimeout(() => el.classList.remove('bump'), 400);
    });
  },

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }
};

/* ===== AJAX ADD TO CART ===== */
const MtlATC = {
  init() {
    document.addEventListener('submit', async e => {
      const form = e.target;
      if (!form.classList.contains('mtl-product-form')) return;
      const submitter = e.submitter || document.activeElement;
      if (
        submitter &&
        !submitter.classList.contains('mtl-atc-btn') &&
        !submitter.classList.contains('mtl-product-add')
      ) {
        return;
      }
      e.preventDefault();

      const btn = submitter && submitter.matches('[type="submit"]') ? submitter : form.querySelector('[type="submit"]');
      const originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span style="opacity:.7">Adding…</span>'; }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || 'Could not add item');

        await MtlCart.refresh();
        MtlToast.show(json.product_title, 'Added to cart ✓');
        MtlCart.open();
      } catch (err) {
        MtlToast.show('Error', err.message, true);
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
      }
    });
  }
};

/* ===== PRODUCT QUICK VIEW ===== */
const MtlQuickView = {
  modal: null,
  overlay: null,
  closeBtn: null,

  init() {
    document.querySelectorAll('[data-product-card]').forEach(card => {
      if (card.dataset.directLinkBound === 'true') return;
      card.dataset.directLinkBound = 'true';
      card.addEventListener('click', event => {
        if (event.target.closest('a, button, form, input, select, textarea')) return;
        if (card.dataset.url) window.location.href = card.dataset.url;
      });
    });
    return;

    this.modal = document.getElementById('mtl-quick-view');
    this.overlay = document.getElementById('mtl-quick-view-overlay');
    this.closeBtn = document.getElementById('mtl-qv-close');
    if (!this.modal || !this.overlay) return;

    document.querySelectorAll('[data-quick-view]').forEach(link => {
      if (link.dataset.qvBound === 'true') return;
      link.dataset.qvBound = 'true';
      link.addEventListener('click', event => {
        const card = link.closest('[data-product-card]');
        if (!card) return;
        event.preventDefault();
        this.open(card);
      });
    });

    if (this.closeBtn && this.closeBtn.dataset.qvBound !== 'true') {
      this.closeBtn.dataset.qvBound = 'true';
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay.dataset.qvBound !== 'true') {
      this.overlay.dataset.qvBound = 'true';
      this.overlay.addEventListener('click', () => this.close());
    }

    this.modal.querySelectorAll('[data-qv-delta]').forEach(btn => {
      if (btn.dataset.qvBound === 'true') return;
      btn.dataset.qvBound = 'true';
      btn.addEventListener('click', () => {
        const input = document.getElementById('mtl-qv-quantity');
        const delta = parseInt(btn.dataset.qvDelta || '0', 10);
        if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') this.close();
    });
  },

  setText(id, text) {
    const el = document.getElementById(id);
    if (el) el.textContent = text || '';
  },

  open(card) {
    const data = card.dataset;
    const image = document.getElementById('mtl-qv-image');
    if (image) {
      image.src = data.image || '';
      image.alt = data.title || '';
      image.closest('.mtl-qv-image-wrap')?.classList.toggle('is-empty', !data.image);
    }

    this.setText('mtl-qv-tag', [data.vendor, data.type].filter(Boolean).join(' · '));
    this.setText('mtl-qv-title', data.title);
    this.setText('mtl-qv-price', data.price);
    this.setText('mtl-qv-compare', data.compare);
    this.setText('mtl-qv-origin', data.origin || 'Mi Tierra Latina selection');
    this.setText('mtl-qv-sku', data.sku || 'Ask in store');
    this.setText('mtl-qv-availability', data.available === 'true' ? 'Available online' : 'Sold out');
    this.setText('mtl-qv-description', data.description || 'Authentic Latin American grocery product selected by Mi Tierra Latina.');

    const compare = document.getElementById('mtl-qv-compare');
    if (compare) compare.hidden = !data.compare;

    const variantInput = document.getElementById('mtl-qv-variant-id');
    if (variantInput) variantInput.value = data.variantId || '';

    const qty = document.getElementById('mtl-qv-quantity');
    if (qty) qty.value = 1;

    const addBtn = document.getElementById('mtl-qv-add');
    if (addBtn) {
      addBtn.disabled = data.available !== 'true';
      addBtn.textContent = data.available === 'true' ? 'Add to cart' : 'Sold out';
    }

    const details = document.getElementById('mtl-qv-details');
    if (details) details.href = data.url || '#';

    this.modal.classList.add('open');
    this.overlay.classList.add('open');
    this.modal.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.closeBtn?.focus(), 30);
  },

  close() {
    if (!this.modal || !this.overlay) return;
    this.modal.classList.remove('open');
    this.overlay.classList.remove('open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.mtl-cart-drawer.open') && !document.querySelector('.mtl-mobile-nav.open')) {
      document.body.style.overflow = '';
    }
  }
};

/* ===== MOBILE PRODUCT FILTERS ===== */
const MtlProductFilters = {
  init() {
    document.querySelectorAll('[data-filter-toggle]').forEach(button => {
      if (button.dataset.filterBound === 'true') return;
      button.dataset.filterBound = 'true';

      button.addEventListener('click', () => {
        const panel = button.closest('.mtl-product-filter-panel');
        const isOpen = panel?.classList.toggle('is-open') || false;
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }
};

/* ===== PRODUCT DESCRIPTION TOGGLE ===== */
const MtlProductDescription = {
  init() {
    document.querySelectorAll('[data-product-description]').forEach(wrapper => {
      const content = wrapper.querySelector('[data-product-description-content]');
      const toggle = wrapper.querySelector('[data-product-description-toggle]');
      if (!content || !toggle) return;

      wrapper.classList.remove('is-collapsible', 'is-open');
      content.style.maxHeight = '';

      const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight) || 24;
      const collapsedHeight = lineHeight * (window.matchMedia('(max-width: 768px)').matches ? 4.4 : 5.2);
      const shouldCollapse = content.scrollHeight > collapsedHeight + 8;
      wrapper.classList.toggle('is-collapsible', shouldCollapse);
      toggle.hidden = !shouldCollapse;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Ver más';

      if (shouldCollapse) {
        content.style.maxHeight = `${collapsedHeight}px`;
      } else {
        content.style.maxHeight = '';
      }

      if (toggle.dataset.descBound === 'true') return;
      toggle.dataset.descBound = 'true';
      toggle.addEventListener('click', () => {
        const isOpen = wrapper.classList.toggle('is-open');
        content.style.maxHeight = isOpen ? 'none' : `${collapsedHeight}px`;
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.textContent = isOpen ? 'Ver menos' : 'Ver más';
      });
    });
  }
};

/* ===== TOAST ===== */
const MtlToast = {
  el: null,
  timer: null,

  init() {
    this.el = document.getElementById('mtl-toast');
  },

  show(title, subtitle = '', isError = false) {
    if (!this.el) return;
    const icon = this.el.querySelector('.mtl-toast-icon');
    const strong = this.el.querySelector('.mtl-toast-text strong');
    const small = this.el.querySelector('.mtl-toast-text small');
    if (icon) icon.textContent = isError ? '!' : '✓';
    if (strong) strong.textContent = title;
    if (small) small.textContent = subtitle;
    this.el.classList.add('show');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.el.classList.remove('show'), 3500);
  }
};

/* ===== MOBILE MENU ===== */
const MtlMobileMenu = {
  init() {
    const btn = document.getElementById('mtl-mobile-menu-btn');
    const nav = document.getElementById('mtl-mobile-nav');
    const close = document.getElementById('mtl-mobile-nav-close');
    if (!btn || !nav) return;
    if (btn.dataset.mobileMenuBound === 'true') return;
    btn.dataset.mobileMenuBound = 'true';

    btn.addEventListener('click', () => {
      const isOpen = nav.classList.contains('open');
      if (isOpen) {
        closeMenu();
        return;
      }
      openMenu();
    });

    const openMenu = () => {
      nav.classList.add('open');
      document.body.style.overflow = 'hidden';
      btn.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      nav.classList.remove('open');
      document.body.style.overflow = '';
      btn.setAttribute('aria-expanded', 'false');
    };

    if (close) close.addEventListener('click', closeMenu);
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && nav.classList.contains('open')) closeMenu();
    });
  }
};

/* ===== SCROLL REVEAL ===== */
const MtlReveal = {
  init() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.mtl-reveal').forEach(el => el.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.mtl-reveal').forEach(el => obs.observe(el));
  }
};

/* ===== PRODUCT PAGE — VARIANT + GALLERY ===== */
const MtlProductPage = {
  init() {
    const details = document.querySelector('.mtl-product-details');
    const form = details?.querySelector('.mtl-product-form');
    if (!form) return;

    // Variant buttons
    details.querySelectorAll('.mtl-variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = btn.dataset.optionIndex;
        details.querySelectorAll(`.mtl-variant-btn[data-option-index="${idx}"]`).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        this.updateVariant(details, form);
      });
    });

    // Qty controls
    const qtyInput = form.querySelector('.mtl-qty-input');
    form.querySelectorAll('.mtl-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const delta = parseInt(btn.dataset.delta || '0');
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) + delta);
      });
    });

    // Thumbnail gallery
    document.querySelectorAll('.mtl-product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.mtl-product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const mainImg = document.querySelector('.mtl-product-main-img img');
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.srcset = thumb.dataset.srcset || '';
        }
      });
    });
  },

  updateVariant(details, form) {
    const variantJson = details.querySelector('[data-product-variants]')?.textContent || '[]';
    const variantData = JSON.parse(variantJson);
    const selectedOptions = [];
    details.querySelectorAll('.mtl-variant-group').forEach(group => {
      const active = group.querySelector('.mtl-variant-btn.active');
      if (active) selectedOptions.push(active.dataset.value);
    });

    const variant = variantData.find(v => v.options.every((o, i) => o === selectedOptions[i]));
    const idInput = form.querySelector('input[name="id"]');
    const submitBtn = form.querySelector('[type="submit"]');
    const priceEl = document.querySelector('.mtl-product-price-main');
    const compareEl = document.querySelector('.mtl-product-compare-main');

    if (variant) {
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = MtlCart.formatMoney(variant.price);
      if (compareEl) {
        compareEl.style.display = variant.compare_at_price > variant.price ? '' : 'none';
        if (variant.compare_at_price > variant.price) compareEl.textContent = MtlCart.formatMoney(variant.compare_at_price);
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.innerHTML = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (variant.featured_image) {
        const mainImg = document.querySelector('.mtl-product-main-img img');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    } else {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Unavailable'; }
    }
  }
};

/* ===== CART PAGE ===== */
const MtlCartPage = {
  init() {
    const page = document.querySelector('.mtl-cart-page');
    if (!page) return;
    page.querySelectorAll('.mtl-cart-line-qty button').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = btn.closest('[data-line]');
        if (!line) return;
        const lineIndex = parseInt(line.dataset.line);
        const input = line.querySelector('input[name="updates[]"]');
        const delta = btn.classList.contains('qty-plus') ? 1 : -1;
        const newQty = Math.max(0, (parseInt(input?.value) || 1) + delta);
        if (input) input.value = newQty;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: newQty })
          });
          window.location.reload();
        } catch (e) { console.error(e); }
      });
    });
  }
};

/* ===== NEWSLETTER ===== */
const MtlNewsletter = {
  init() {
    document.querySelectorAll('.mtl-newsletter-form').forEach(form => {
      // Native Shopify customer form handles this — just intercept client-side feedback
      form.addEventListener('submit', () => {
        const btn = form.querySelector('button[type="submit"]');
        if (btn) setTimeout(() => { btn.textContent = '✓ Subscribed!'; }, 100);
      });
    });
  }
};

/* ===== COUNTRY COLLECTION FILTER ===== */
const MtlCountryFilter = {
  init() {
    document.querySelectorAll('[data-mtl-country-shop]').forEach(shop => {
      const triggers = shop.querySelectorAll('[data-country-trigger]');
      const panels = shop.querySelectorAll('[data-country-panel]');
      const prompt = shop.querySelector('[data-country-prompt]');

      const showCountry = country => {
        let found = false;
        triggers.forEach(trigger => {
          const isActive = trigger.dataset.country === country;
          trigger.classList.toggle('active', isActive);
          if (isActive) found = true;
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.countryPanel !== country;
        });
        if (prompt) prompt.hidden = found;
        if (found) {
          const target = shop.querySelector('#country-products');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
          if (!trigger.dataset.country) return;
          event.preventDefault();
          showCountry(trigger.dataset.country);
          const url = new URL(window.location.href);
          url.searchParams.set('country', trigger.dataset.country);
          url.hash = 'country-products';
          window.history.replaceState({}, '', url.toString());
        });
      });

      shop.querySelectorAll('[data-country-reset]').forEach(button => {
        button.addEventListener('click', () => {
          triggers.forEach(trigger => trigger.classList.remove('active'));
          panels.forEach(panel => { panel.hidden = true; });
          if (prompt) prompt.hidden = false;
          const url = new URL(window.location.href);
          url.searchParams.delete('country');
          url.hash = '';
          window.history.replaceState({}, '', url.toString());
          shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      const initialCountry = new URLSearchParams(window.location.search).get('country') || window.location.hash.replace('#country-', '');
      if (initialCountry) showCountry(initialCountry);
    });
  }
};

/* ===== SHOPIFY SECTION RELOAD ===== */
document.addEventListener('shopify:section:load', () => {
  MtlNavScroll.init();
  MtlReveal.init();
  MtlCart.init();
  MtlMobileMenu.init();
  MtlProductPage.init();
  MtlNewsletter.init();
  MtlCountryFilter.init();
  MtlQuickView.init();
  MtlProductFilters.init();
  MtlProductDescription.init();
});

/* ===== BOOT ===== */
document.addEventListener('DOMContentLoaded', () => {
  MtlNavScroll.init();
  MtlCart.init();
  MtlATC.init();
  MtlToast.init();
  MtlMobileMenu.init();
  MtlReveal.init();
  MtlProductPage.init();
  MtlCartPage.init();
  MtlNewsletter.init();
  MtlCountryFilter.init();
  MtlQuickView.init();
  MtlProductFilters.init();
  MtlProductDescription.init();
});
